import affiliate from './affiliate';
import auth from './auth';
import billing from './billing';
import bulkEdit from './bulkEdit';
import connectProfile from './connectProfile';
import data from './data';
import edit from './edit';
import listings from './listings';
import notifications from './notifications';
import profiles from './profiles';
import schedule from './schedule';
import selectMedia from './selectMedia';
import shops from './shops';
import studio from './studio';
import user from './user';

const actions = {
  affiliate,
  auth,
  billing,
  bulkEdit,
  connectProfile,
  data,
  edit,
  listings,
  notifications,
  profiles,
  schedule,
  selectMedia,
  shops,
  studio,
  user,
};

export default actions;
